import React, { lazy } from "react";
import Loadable from "components/Loadable";

// Define lazy-loaded components
const QOList = Loadable(lazy(() => import("../QOList")));
const QOYearWiseList = Loadable(lazy(() => import("../QOYearWiseList")));
const ViewById = Loadable(lazy(() => import("../ViewById")));
const AddEditQO = Loadable(lazy(() => import("../AddEditQO")));
const QODetails = Loadable(lazy(() => import("../QODetails")));

// Define routes using lazy-loaded component
const QORoutes = [
  {
    path: "quality-objective",
    children: [
      { path: "details/:type", element: <QOList /> },
      { path: "year-wise-list/", element: <QOYearWiseList /> },
      { path: ":year/:id", element: <ViewById /> },
      { path: "qality-objective-detail/:id/:type", element: <QODetails /> },
      { path: "edit/:fId/:type", element: <AddEditQO /> },
    ],
  },
];

export default QORoutes;
